import React from 'react';

const Permissions = () => {
    // Definir la estructura de permisos (este es un ejemplo, se puede adaptar)
    const permissions = [
        {
            role: 'Director',
            permissions: {
                users: ['create', 'read', 'update', 'delete'],
                steps: ['create', 'read', 'update', 'delete'],
            },
        },
        {
            role: 'Navegador',
            permissions: {
                users: ['create', 'read', 'update', 'delete'],
                steps: ['create', 'read'],
            },
        },
        {
            role: 'Lector',
            permissions: {
                users: ['read'],
                steps: ['read'],
            },
        },
        {
            role: 'Paciente',
            permissions: {
                users: [],
                steps: [],
            },
        },
    ];

    return (
        <div>
            <h1>Permisos por Rol</h1>
            <table>
                <thead>
                    <tr>
                        <th>Rol</th>
                        <th>Entidad</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {permissions.map((rolePermissions) => (
                        Object.keys(rolePermissions.permissions).map((entity) => (
                            <tr key={`${rolePermissions.role}-${entity}`}>
                                <td>{rolePermissions.role}</td>
                                <td>{entity}</td>
                                <td>{rolePermissions.permissions[entity].join(', ')}</td>
                            </tr>
                        ))
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Permissions;
